import { render, staticRenderFns } from "./RervesePayInstallment.vue?vue&type=template&id=a4c84e18"
import script from "./RervesePayInstallment.vue?vue&type=script&lang=js"
export * from "./RervesePayInstallment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports